import * as React from "react";
import { cn } from "@/lib/utils";

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "search" | "error" | "success";
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, title, description, action, size = "md", variant = "default", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("wl-empty-state", `wl-empty-state-${size}`, `wl-empty-state-${variant}`, className)}
        {...props}
      >
        {icon && (
          <div className="wl-empty-state-icon">
            {icon}
          </div>
        )}
        {title && (
          <h3 className="wl-empty-state-title">
            {title}
          </h3>
        )}
        {description && (
          <p className="wl-empty-state-description">
            {description}
          </p>
        )}
        {action && (
          <div className="wl-empty-state-action">
            {action}
          </div>
        )}
      </div>
    );
  }
);

EmptyState.displayName = "EmptyState";

export { EmptyState }; 